import type { Deal, Promo } from '../../../types/Deal';
import type { Widget } from '../../../types/Widget';
import type { WidgetProps } from '../../../types/WidgetProps';
import type Localiser from '../../Localiser';
import type { Site } from '../../sites/Site';

import { addCtaToDeal } from './addCtaToDeal';
import { getCustomTrackedOffer } from './getCustomTrackedOffer';
import { getPromos } from './getPromos';

export type FormattedOffer = Deal & { promos: Promo[] };

export const formatSingleOffer = async ({
  deal,
  localiser,
  localisedLinkText,
  showPrice = '',
  showWasPrice = 'noPrice',
  showPromos,
  customPromo,
  customPromos,
  excludeFrom,
  site,
  area,
  articleName,
  articleType,
  articleCategory,
  trackingArea,
  articleUrl,
  params,
  widget,
  link,
  social,
}: {
  deal: Deal;
  localiser: Localiser;
  localisedLinkText: string;
  showPrice?: string;
  showWasPrice?: string;
  showPromos?: boolean;
  customPromo?: string;
  customPromos?: string;
  excludeFrom?: string;
  site: Site;
  area: string | null;
  articleName: string;
  articleType?: string;
  articleCategory?: string;
  trackingArea?: string;
  articleUrl: string;
  params: WidgetProps['params'];
  widget: Widget;
  link?: string;
  social?: string;
}): Promise<FormattedOffer> => {
  const ctaDeal = addCtaToDeal({
    localiser,
    localisedLinkText,
    showPrice,
    widget,
    deal,
  });

  const promos = getPromos({
    showWasPrice,
    localiser,
    deal: ctaDeal,
    customPromo,
    customPromos,
    excludeFrom,
    showPromos,
    widget,
  });

  const customTrackedOffer = await getCustomTrackedOffer({
    deal: ctaDeal,
    site,
    articleName,
    articleUrl,
    battle: params.battle,
    area: area ?? undefined,
    link,
    linkText: localisedLinkText,
    widgetType: widget.type,
    articleType,
    articleCategory,
    social,
    trackingArea,
  });

  return {
    ...ctaDeal,
    ...customTrackedOffer,
    promos,
  };
};
